module.exports = __webpack_public_path__ + "static/media/gwbilbord01.5d8944e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Goodwill/gwbilbord01.jpg
// module id = 378
// module chunks = 0